<template>
  <div>
    <router-view />
  </div>
</template>
<script>
  export default {
    name: "SynthesizeQuality"
  };
</script>

<style scoped lang="less">
</style>
